/* global $ */

(function (scope) {
  "use strict";

  var PrintToolsView = (scope.PrintToolsView = function (controller, design) {
    this.controller = controller;
    this.design = design;
    this.$el = $("#PrintToolsView");
    this.$el.on(
      "click",
      "a:not(.disabled):not(.active)",
      this.toolChanged.bind(this)
    );

    // $('#lasercut-legend-setter-widget').delegate(".legendName .legendChip", "mouseenter", function (event) {
    //   939  					SvgViewer.highlight($(event.currentTarget).closest('.legendLine').data('style-id'));
    //   940  				});
    //   941
    //   942: 				$('#lasercut-legend-setter-widget').delegate(".legendName .legendChip", "mouseleave", function (event) {
    //   943  					SvgViewer.unhighlight();
    //   944  				});
    //   945
    //   946: 				$('#lasercut-legend-setter-widget').delegate(".legendName .legendChip", "click", function (event) {
    //   947  					SvgViewer.selectElementsWithStyle($(event.currentTarget).closest('.legendLine').data('style-id'));
    //   948  				});

    this.$el.on(
      "mouseenter",
      ".legendName .legendChip",
      this.legendchipOver.bind(this)
    );
    this.$el.on(
      "mouseleave",
      ".legendName .legendChip",
      this.legendchipLeave.bind(this)
    );
    this.$el.on(
      "click",
      ".legendName .legendChip",
      this.legendchipClick.bind(this)
    );
  });

  PrintToolsView.prototype.toolChanged = function (e) {
    e.preventDefault();

    var tool = $(e.currentTarget).data("tool");
    this.controller.switchTool(tool);
  };

  PrintToolsView.prototype.setActive = function (tool) {
    $("a", this.$el).removeClass("active");
    $(".tool-tab", this.$el).removeClass("active");

    $("[data-tool=" + tool + "]").toggleClass("active");
    $("[data-tool=" + tool + "]")
      .parent()
      .toggleClass("active");
  };

  PrintToolsView.prototype.legendchipOver = function (evt) {
    SvgViewer.highlight(
      $(evt.currentTarget).closest(".legendLine").data("style-id")
    );
  };

  PrintToolsView.prototype.legendchipLeave = function (evt) {
    SvgViewer.unhighlight();
  };

  PrintToolsView.prototype.legendchipClick = function (evt) {
    SvgViewer.selectElementsWithStyle(
      $(evt.currentTarget).closest(".legendLine").data("style-id")
    );
  };

  PrintToolsView.TOOLS = {};
  PrintToolsView.TOOLS.DASHBOARD = "dashboard";
  PrintToolsView.TOOLS.ORIENTATION = "orientation";
  PrintToolsView.TOOLS.BATCH_CONTROL = "batch";
  PrintToolsView.TOOLS.HOLLOWING = "hollowing";
  PrintToolsView.TOOLS.THICKENING = "thickening";
  PrintToolsView.TOOLS.ANNOTATIONS = "annotations";
  PrintToolsView.TOOLS.SLICER = "slicer";
  PrintToolsView.TOOLS.CONFIGURATION = "configuration";
  PrintToolsView.TOOLS.REVIEW = "review";
})((window.sculpteo = window.sculpteo || {}));
